import { z } from 'zod';
/**
 * POST /donations — 후원 결제 요청 DTO (Wave 0 골격).
 *
 * 배경 (STACK.md 축4 · ARCHITECTURE §3):
 * - `customerKey` 는 UUID 필수 (Toss 정책 — 이메일·숫자 ID 금지).
 * - 응답에는 Toss `paymentClientKey` + `orderId` 포함 — 클라이언트 SDK 초기화용.
 * - `amountKrw` 는 plain number (int, >0) — 브랜드 타입은 내부 서비스 경계에서만 사용.
 *
 * 실제 라우터·서비스 배선은 Plan 01-04 (Toss SDK 설치 후). 본 plan 은 DTO 스키마만.
 */
/** POST /donations — 요청 body */
export const createDonationRequestSchema = z.object({
    streamerId: z.string().uuid(),
    /** 후원 금액 (KRW). 정수, 최소 100원 (Toss 최소 결제금액) */
    amountKrw: z.number().int().positive().min(100),
    /** 위젯에 표시될 닉네임 */
    nickname: z.string().min(1).max(32),
    /** 응원 메시지 (nullable — 없는 경우 TTS 스킵) */
    message: z.string().max(200).nullable(),
    /** Toss `customerKey` — UUID 필수 */
    customerKey: z.string().uuid(),
});
/** POST /donations — 성공 응답 body */
export const createDonationResponseSchema = z.object({
    donationId: z.string().uuid(),
    /** Toss SDK 초기화용 클라이언트 키 (Public) */
    paymentClientKey: z.string().min(1),
    /** Toss `orderId` — 결제창 trigger 시 사용 */
    orderId: z.string().min(1),
});
//# sourceMappingURL=donation.rest.js.map